/**
 * 步骤2结构模板
 * 将你的模板内容复制到 content 字段中
 */
export default {
  id: 'step2',
  name: '步骤2结构模板',
  description: '用于步骤2的提示词结构模板',
  content: `你是专业的柴油车数据分析专家。请根据下面的工况定义，判断给定的CSV数据采集文件属于哪一种工况，只输出工况名称，不要输出其他内容。

  工况定义：
  {chr(10).join(CONDITIONS)}
  
  请严格按照工况定义中的描述进行判断。
  
  CSV文件内容如下：
  {csv_content}
  `
};
